// extracted by mini-css-extract-plugin
export var addToCartButton = "_gx-b";
export var arrowButtonContainer = "_gx-9";
export var arrowButtonIcon = "_gx-a";
export var carouselArrowButton = "_gx-6";
export var carouselElementContainer = "_gx-1";
export var left = "_gx-7";
export var productDisplayCarouselContainer = "_gx-0";
export var productTileContainer = "_gx-2";
export var productTileImage = "_gx-4";
export var productTileImageContainer = "_gx-3";
export var productTileTitle = "_gx-5";
export var right = "_gx-8";
export var sliderOverflow = "_gx-c";